<div class="error-message text-center">
    <div *ngFor="let error of errors">
        <span *ngIf="!!error.validation">{{ error.validation }}</span>
        <span *ngIf="!!error.payment" class="stripe-error" [ngbTooltip]="error.payment">Show details</span>
    </div>
</div>
